import { UserContext } from "@/context/User/UserContext";
import { getInsurers } from "@/services/Insurer.service";
import { Insurer } from "@/types/insurer.types";
import { useQuery } from "@tanstack/react-query";
import { ColumnDef } from "@tanstack/react-table";
import { useContext } from "react";
import { NavLink } from "react-router-dom";
import CreateInsurer from "../dialog/CreateInsurer";
import ColumnHeader from "../table/ColumnHeader";
import LawFirmTable from "../table/LawFirmTable";
import { Button } from "../ui/button";
import { Skeleton } from "../ui/skeleton";

const Insurers = () => {
	const user = useContext(UserContext);

	const insurers = useQuery({
		queryKey: ["insurers"],
		queryFn: () => getInsurers(user?.accessToken!),
		enabled: !!user?.accessToken,
		staleTime: 3000,
	});
	return (
		<div>
			<div className="flex justify-between items-center mb-4">
				<div>
					<h1 className="text-3xl font-bold">Insurers</h1>
				</div>
				<CreateInsurer user={user} />
			</div>
			<div className="bg-white pb-4 border rounded-md shadow-sm">
				{insurers.isLoading ? (
					<div className="grid gap-4 pt-4">
						{Array.from({ length: 10 }).map((_, num) => (
							<Skeleton key={num} className="h-12 w-full" />
						))}
					</div>
				) : insurers.data ? (
					<LawFirmTable data={insurers.data} columns={Columns} />
				) : (
					<p>No data</p>
				)}
			</div>
		</div>
	);
};

export default Insurers;

const Columns: ColumnDef<Insurer>[] = [
	{
		accessorKey: "insurerid",
		header: ({ column }) => <ColumnHeader column={column} title="Insurer Id" />,
		cell: ({ row }) => (
			<div className="flex items-center">
				<NavLink to={`/insurer/${row.original.insurerid}`}>
					<Button variant="link" className="px-2 py-1 font-light">
						{row.getValue("insurerid")}
					</Button>
				</NavLink>
			</div>
		),
	},
	{
		accessorKey: "insurername",
		header: ({ column }) => <ColumnHeader column={column} title="Insurer" />,
	},
	{
		accessorKey: "actions",
		cell: ({ row }) => (
			<div className="flex items-center">
				<NavLink to={`/insurer/${row.original.insurerid}`}>
					<Button variant="link" className="px-2 py-1 font-light">
						View
					</Button>
				</NavLink>
			</div>
		),
	},
];
